import { ISingleIdParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetPreferredRefreshOptionResult extends IResult {
  suggestion: number; // One of Datasources:RefreshOptionType
  dataSyncSupported: boolean;
  serverRefreshSupported: boolean;
  reachable: boolean; // Fuzzy check if we are likely able to connect to the DS
}

export interface IGetPreferredRefreshOptionByUrlNameResult extends _.Dictionary<IGetPreferredRefreshOptionResult> {
}

export interface IGetPreferredRefreshOptionByUrlNameParams {
  urlNames: string[];
}

export class GetPreferredRefreshOptionRequest extends Request<ISingleIdParams, IGetPreferredRefreshOptionResult> {
  constructor(params: ISingleIdParams) {
    super('getPreferredRefreshOption', params);
  }
}

export class GetPreferredRefreshOptionByUrlNameRequest extends Request<IGetPreferredRefreshOptionByUrlNameParams, IGetPreferredRefreshOptionByUrlNameResult> {
  constructor(params: IGetPreferredRefreshOptionByUrlNameParams) {
    super('getPreferredRefreshOptionByUrlName', params);
  }
}
